<template>
  <div class="purchase-report-page">
    <div class="purchase-report-table">
      <a-tabs :default-active-key="getDefaultNumber()" @change="callback">
        <a-tab-pane key="1">
          <div slot="tab" class="tab-title" v-has="'statistical_procurement_goods_dimensionality'">
            <span class="icon-image icon-image-shangpin"></span>
            <span>按采购商品</span>
          </div>
          <a-row class="inquire-module" id="page-top">
            <a-row :gutter="24">
              <a-col :md="4" :sm="6">
                <!-- <a-range-picker v-model="dateValue" format="YYYY-MM-DD" @change="changeData" /> -->
                <a-range-picker :disabled-date="disabledDate" :disabled-time="disabledRangeTime" format="YYYY-MM-DD"
                  v-model="dateValue" @change="changeData" />
              </a-col>
              <a-col :md="4" :sm="6">
                <a-tree-select class="tree-manage" v-model="formData.typeName" style="width: 100%"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="classObj" allow-clear
                  placeholder="请选择商品分类" tree-default-expand-all @change="changeType">
                  <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
                </a-tree-select>
              </a-col>
              <a-col :md="4" :sm="6">
                <a-input placeholder="输入关键词搜索" v-model="formData.keywords" />
              </a-col>
              <a-col :md="4" :sm="6" class="button-ant-col">
                <a-button class="ant-btn-color border-arc" @click="btnInquire">查询</a-button>
                <a-button class="border-arc" @click="btnResetData">重置</a-button>
              </a-col>
              <a-col :md="8" :sm="6" class="button-add-col">
                <a-button icon="printer" type="primary border-arc" v-has="'statistical_procurement_balance_report_print'" @click="btnPrint">打印</a-button>
              </a-col>
            </a-row>
          </a-row>
          <a-row class="table-box" :style="{height: contentHeight+'px'}">
            <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id"
              :scroll="{ x: 1000, y: (tableHeight) }" bordered>
              <!-- 序号 -->
              <template slot="serialNum" slot-scope="text, record, index">
                <span>{{  index+1 }}</span>
              </template>
              <template slot="danhao" slot-scope="text, record, index">
                <img src="@/assets/image/make_offers_tubiao.png" alt="" style="width:14px;margin-right:8px"
                  v-if="index==2">
                <span>{{ text }}</span>
              </template>
              <template slot="footer">
                <div class="footer-total-amount">
                  <div class="footer-total-amount-left" style="width: 80px">
                    <span class="title">小计</span>
                  </div>
                  <div class="footer-total-amount-right" v-if="footerDataSource.length>0">
                    <span class="right-col">采购数量：{{ footerDataSource[0].purchaseCount }}</span>
                    <span class="right-col">金额：{{ footerDataSource[0].totalAmount }}</span>
                  </div>
                </div>
              </template>
            </a-table>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="2" force-render>
          <div slot="tab" class="tab-title" v-has="'statistical_procurement_units_dimensionality'">
            <span class="icon-image icon-image-gongying"></span>
            <span>按供应商</span>
          </div>
          <a-row class="inquire-module" id="page-top">
            <a-row :gutter="24">
              <a-col :md="4" :sm="6">
                <a-range-picker :disabled-date="disabledDate" :disabled-time="disabledRangeTime" format="YYYY-MM-DD"
                  v-model="dateValue" @change="changeData" />
              </a-col>
              <a-col :md="4" :sm="6">
                <a-select id="steps-03" style="width: 100%;" v-model="formData.contactCustomerName" placeholder="请选择往来单位类别"
                  @change="selectcontactNametype">
                  <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
                  <a-select-option v-for="(item, index) in contactNameList" :key="index">{{ item.name }}</a-select-option>
                </a-select>
              </a-col>
              <a-col :md="4" :sm="6">
                <a-input placeholder="输入关键词搜索" v-model="formData.keywords" />
              </a-col>
              <a-col :md="4" :sm="6" class="button-ant-col">
                <a-button class="ant-btn-color border-arc" @click="btnInquire">查询</a-button>
                <a-button class="border-arc" @click="btnResetData">重置</a-button>
              </a-col>
              <a-col :md="8" :sm="6" class="button-add-col">
                <a-button icon="printer" type="primary border-arc" v-has="'statistical_procurement_balance_report_print'" @click="btnPrint">打印</a-button>
              </a-col>
            </a-row>
          </a-row>
          <a-row class="table-box" :style="{height: contentHeight+'px'}">
            <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id"
              :scroll="{x: 1000, y: (tableHeight) }" bordered>
              <!-- 序号 -->
              <template slot="serialNum" slot-scope="text, record, index">
                <span>{{  index+1 }}</span>
              </template>
              <template slot="footer">
                <div class="footer-total-amount">
                  <div class="footer-total-amount-left" style="width: 80px">
                    <span class="title">小计</span>
                  </div>
                  <div class="footer-total-amount-right" v-if="footerDataSource.length>0">
                    <span class="right-col">订单笔数：{{ footerDataSource[0].transactionNumber }}</span>
                    <span class="right-col">成交金额：{{ footerDataSource[0].transactionAmount }}</span>
                  </div>
                </div>
              </template>
            </a-table>
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div class="pagination-box">
      <a-pagination :total="ipagination.total" :page-size="ipagination.pageSize" :default-current="ipagination.current"
        :show-total="ipagination.showTotal" @showSizeChange="onShowSizeChange" @change="onChangeIpagination"
        show-size-changer show-quick-jumper />
    </div>
    <preview-print ref="printPreview"></preview-print>
  </div>
</template>
<script>
import moment from "moment";
import pick from "lodash.pick";
import { tableWidth } from "@/mixins/tableWidth";
import { classificationList, getSellReportList, contactList } from "@/utils/api";
import previewPrint from '@/components/print/previewPrint.vue'
export default {
  name: "purchaseReport",
  mixins: [tableWidth],
  components: {
    previewPrint
  },
  data() {
    return {
      columns: [
        {
          width: 80,
          title: "序号",
          align: "center",
          fixed: "left",
          dataIndex: "serialNum",
          scopedSlots: { customRender: "serialNum" },
        },
        {
          width: 200,
          title: "商品名称",
          fixed: "left",
          dataIndex: "productName",
        },
        {
          tdNum: 200,
          title: "商品编号",
          dataIndex: "productCode",
          scopedSlots: { customRender: "productCode" },
        },
        {
          tdNum: 200,
          title: "规格",
          dataIndex: "productSkuName",
        },
        {
          tdNum: 150,
          title: "型号",
          dataIndex: "productSpecification",
        },
        {
          tdNum: 120,
          title: "单位",
          dataIndex: "productUnit",
        },
        {
          tdNum: 150,
          title: "平均单价",
          align: "right",
          dataIndex: "price",
        },
        {
          tdNum: 150,
          title: "采购数量",
          align: "right",
          dataIndex: "purchaseCount",
        },
        {
          width: 150,
          title: "采购金额",
          fixed: "right",
          dataIndex: "totalAmount",
        },
      ], // 表格表头
      footerDataSource: [
        {
          serialNum: "小计",
          purchaseCount: 0,
          totalAmount: 0,
          transactionNumber: 0,
          transactionAmount: 0,
        },
      ],
      type: 1,
      classObj: [],
      dataSource: [],
      formData: {},
      ipagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条";
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 100,
      },
      dateValue: null,
      tableHeight: "",
      contentHeight: "",
      urlList: {
        list: "/report/api/reportPurchase/pagePurchaseProductListByCondition",
        price: "/report/api/reportPurchase/findTotalPurchaseProductByCondition",
      },
      contactNameList:[],
    };
  },
  activated() {
    // 表格高度计算
    let _that = this
    setTimeout(function() {
      let tabsTitleHeight = document.getElementsByClassName("ant-tabs-top-bar")[1].offsetHeight;
      let tdHeight = document.getElementsByTagName("tr")[0].offsetHeight;
      let header = document.getElementById("header").offsetHeight;
      let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
      let pageHeight = document.getElementById("content").offsetHeight;
      let makeTop = document.getElementById("page-top").offsetHeight;
      _that.contentHeight = pageHeight - makeTop - tabsTitleHeight - header - breadcrumb - tdHeight * 0.8;
      _that.tableHeight = _that.contentHeight - tdHeight * 2;
    }, 50)
    if(this.$comm.has('statistical_procurement_goods_dimensionality')) {
      this.callback(1)
    } else {
      this.callback(2)
    }
    this.getList();
    this.getClassList();
    this.getListPrice();
    this.getDepartMessage()
  },
  methods: {
    // 获取默认
    getDefaultNumber() {
      let number = '1'
      if(this.$comm.has('statistical_procurement_goods_dimensionality')) {
        number = '1'
      } else {
        number = '2'
      }
      return number
    },
    // 时间相关函数
    moment,
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },

    disabledDate(current) {
      return current && current > moment().endOf("day");
    },

    disabledRangeTime(_, type) {
      if (type === "start") {
        return {
          disabledHours: () => this.range(0, 60).splice(4, 20),
          disabledMinutes: () => this.range(30, 60),
          disabledSeconds: () => [55, 56],
        };
      }
      return {
        disabledHours: () => this.range(0, 60).splice(20, 4),
        disabledMinutes: () => this.range(0, 31),
        disabledSeconds: () => [55, 56],
      };
    },
    // 选择筛选日期
    changeData(date, dateString) {
      this.dateValue = date;
      this.formData.startDate = dateString[0];
      this.formData.endDate = dateString[1];
    },
    // 选择商品类别
    getClassList() {
      let data = {
        companyStoreId: this.$store.state.shopId,
      };
      data = this.$qs.stringify(data);
      classificationList(data, {}).then((res) => {
        if (res.success) {
          res.result.forEach((item) => {
            item.title = item.categoryName;
            item.value = item.id;
            item.key = item.id;
            item.selectable = false;
            item.children.forEach((item1) => {
              item1.title = item1.categoryName;
              item1.value = item1.id;
              item1.key = item1.id;
              item1.selectable = false;
              item1.children.forEach((item2) => {
                item2.title = item2.categoryName;
                item2.value = item2.id;
                item2.key = item2.id;
              });
            });
          });
          this.classObj = res.result;
        }
      });
    },
    // 获取往来单位类别
    getDepartMessage(){
      let data = new FormData()
      data.append('companyStoreId',this.$store.state.shopId)
      contactList(data,{'Content-Type':'application/json'}).then((res)=>{
          if(res.success){
              this.contactNameList = res.result
          }
      })
    },
    // 选择往来单位类别
    selectcontactNametype(e) {
      this.formData.contactCustomerCategoryId = this.contactNameList[e].id
    },
    changeContactCustomer() {
      if (!this.formData.contactCustomerName) {
        this.formData.contactCustomerId = ''
        this.btnInquire()
      }
    },
    // 选择类别
    changeType(e, c) {
      this.formData.categoryId3 = e;
      this.formData.typeName = c;
    },
    // 选择页数
    onShowSizeChange(current, pageSize) {
      this.ipagination.current = current;
      this.ipagination.pageSize = pageSize;
      this.getList();
      this.getListPrice();
    },
    // 选择有一页显示数目
    onChangeIpagination(current) {
      this.ipagination.current = current;
      this.getList();
      this.getListPrice();
    },
    // 查询
    btnInquire() {
      this.getList();
      this.getListPrice();
    },
    // 重置
    btnResetData() {
      this.dateValue = null;
      this.formData = {
        contactCustomerName: undefined,
      };
      this.getList();
      this.getListPrice();
    },
    // 选择仓库
    selectWarehouse() {},
    // 选择状态
    callback(e) {
      if (e == 1) {
        this.columns = [
          {
            width: 80,
            title: "序号",
            align: "center",
            fixed: "left",
            dataIndex: "serialNum",
            scopedSlots: { customRender: "serialNum" },
          },
          {
            width: 200,
            title: "商品名称",
            fixed: "left",
            dataIndex: "productName",
          },
          {
            tdNum: 200,
            title: "商品编号",
            dataIndex: "productCode",
            scopedSlots: { customRender: "productCode" },
          },
          {
            tdNum: 200,
            title: "规格",
            dataIndex: "productSkuName",
          },
          {
            tdNum: 150,
            title: "型号",
            dataIndex: "productSpecification",
          },
          {
            tdNum: 120,
            title: "单位",
            dataIndex: "productUnit",
          },
          {
            tdNum: 150,
            title: "平均单价",
            align: "right",
            dataIndex: "price",
          },
          {
            tdNum: 150,
            title: "采购数量",
            align: "right",
            dataIndex: "purchaseCount",
          },
          {
            width: 150,
            title: "采购金额",
            fixed: "right",
            dataIndex: "totalAmount",
          },
        ] 
        this.urlList.list =
          "/report/api/reportPurchase/pagePurchaseProductListByCondition";
        this.urlList.price =
          "/report/api/reportPurchase/findTotalPurchaseProductByCondition";
      } else if (e == 2) {
        this.columns = [
          {
            width: 80,
            title: "序号",
            align: "center",
            dataIndex: "serialNum",
            scopedSlots: { customRender: "serialNum" },
          },
          {
            tdNum: 200,
            title: "供应商名称",
            dataIndex: "contactCustomerName",
          },
          {
            tdNum: 200,
            title: "供应商编号",
            dataIndex: "contactCustomerCode",
          },
          {
            tdNum: 150,
            title: "联系电话",
            dataIndex: "contactCustomerMobile",
          },
          {
            tdNum: 150,
            title: "供应商类别",
            dataIndex: "contactCustomerCategoryName",
          },
          {
            width: 200,
            title: "所在区域",
            dataIndex: "contactCustomerAreaStr",
          },
          {
            tdNum: 150,
            title: "订单笔数",
            align: "right",
            dataIndex: "transactionNumber",
          },
          {
            tdNum: 150,
            title: "成交金额",
            dataIndex: "transactionAmount",
          },
        ];
        this.urlList.list =
          "/report/api/reportPurchase/pagePurchaseContactCustomerListByCondition";
        this.urlList.price =
          "/report/api/reportPurchase/findTotalPurchaseContactCustomerByCondition";
      }
      this.type = e;
      this.handleResize();
      this.getList();
      this.getListPrice();
    },
    // 打印弹框
    btnPrint() {
      let templateType = 50501
      if(this.type == 1) {
        templateType = 50501
        sessionStorage.setItem(
          "purchaseReport",
          JSON.stringify({
            type: this.type,
            categoryId1: this.formData.categoryId1,
            categoryId2: this.formData.categoryId2,
            categoryId3: this.formData.categoryId3,
            keywords: this.formData.keywords,
          })
        );
      } else if(this.type == 2) {
        templateType = 50502
        sessionStorage.setItem(
          "purchaseReport",
          JSON.stringify({
            type: this.type,
            contactCustomerCategoryId: this.formData.contactCustomerCategoryId,
            keywords: this.formData.keywords,
          })
        );
      }
      this.$refs.printPreview.open({
        templateType: templateType,
        total:this.ipagination.total,
        endTime: this.formData.endDate,
        startTime: this.formData.startDate,
      })
    },
    // 获取数据列表
    getList() {
      let params = {};
      let data = {
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
      };
      if (this.type == 1) {
        params = {
          companyId: this.$store.state.userInfo.companyId,
          companyStoreId: this.$store.state.userInfo.companyStoreId,
          categoryId1: this.formData.categoryId1,
          categoryId2: this.formData.categoryId2,
          categoryId3: this.formData.categoryId3,
          startDate: this.formData.startDate,
          endDate: this.formData.endDate,
          keywords: this.formData.keywords,
        };
      } else if (this.type == 2) {
        params = {
          companyId: this.$store.state.userInfo.companyId,
          companyStoreId: this.$store.state.userInfo.companyStoreId,
          contactCustomerCategoryId: this.formData.contactCustomerCategoryId,
          startDate: this.formData.startDate,
          endDate: this.formData.endDate,
          keywords: this.formData.keywords,
        };
      }
      this.$store.state.isLoding = true;
      getSellReportList(this.urlList.list, params, {}, data).then((res) => {
        if (res.code == 200) {
          this.dataSource = res.result.records;
          this.ipagination.total = parseInt(res.result.total);
          this.$store.state.isLoding = false;
        } else {
          this.$message.error(res.logMessage);
        }
      });
    },
    // 获取总价格
    getListPrice() {
      let params = {};
      let data = {
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
      };
      if (this.type == 1) {
        params = {
          companyId: this.$store.state.userInfo.companyId,
          companyStoreId: this.$store.state.userInfo.companyStoreId,
          categoryId1: this.formData.categoryId1,
          categoryId2: this.formData.categoryId2,
          categoryId3: this.formData.categoryId3,
          startDate: this.formData.startDate,
          endDate: this.formData.endDate,
          keywords: this.formData.keywords,
        };
      } else if (this.type == 2) {
        params = {
          companyId: this.$store.state.userInfo.companyId,
          companyStoreId: this.$store.state.userInfo.companyStoreId,
          contactCustomerCategoryId: this.formData.contactCustomerCategoryId,
          startDate: this.formData.startDate,
          endDate: this.formData.endDate,
          keywords: this.formData.keywords,
        };
      }
      getSellReportList(this.urlList.price, params, {}, data).then((res) => {
        if (res.code == 200) {
          if (this.type == 1) {
            this.footerDataSource[0].purchaseCount = res.result.purchaseCount;
            this.footerDataSource[0].totalAmount = res.result.totalAmount;
          } else if (this.type == 2) {
            this.footerDataSource[0].transactionNumber =
              res.result.transactionAmount;
            this.footerDataSource[0].transactionAmount =
              res.result.transactionAmount;
          }
        } else {
          this.$message.error(res.logMessage);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.purchase-report-page {
  .inquire-module {
    height: 80px;
    padding: 0 25px;
    background-color: #ffffff;
    .ant-row {
      height: 80px !important;
      display: flex;
      align-items: center;
    }
    .ant-form-item-children {
      width: 100%;
      .ant-calendar-picker {
        width: 100%;
      }
      .ant-calendar-picker-input {
        width: 100% !important;
      }
    }
    .button-ant-col {
      display: flex;
      .ant-btn {
        width: 80px !important;
      }
      .ant-btn-color {
        margin-right: 16px;
      }
    }
    .button-add-col {
      display: flex;
      justify-content: flex-end;
      .add-make-button {
        color: #f76f14;
        cursor: pointer;
        .ant-btn-primary {
          width: 40px;
          height: 40px;
          border-radius: 50% !important;
          margin-right: 8px;
        }
      }
    }
    .ant-form-item {
      margin-bottom: 0 !important;
    }
  }
  .purchase-report-table {
    .table-box {
      margin-top: 16px;
      background-color: #ffffff;
    }
    .ant-tabs-bar {
      height: 64px;
      display: flex;
      align-items: center;
      background-color: #ffffff;
      margin: 0;
      .ant-tabs-ink-bar {
        display: none !important;
        background-color: var(--co);
      }
      .ant-tabs-tab {
        margin: 0;
        .tab-title {
          height: 32px;
          display: flex;
          align-items: center;
        }
        .icon-image {
          display: inline-block;
          width: 32px;
          height: 32px;
          background-size: 100%;
          margin-right: 8px;
        }
        .icon-image-shangpin {
          background-image: url("../../../assets/image/icon_cgsp wxz.png");
        }
        .icon-image-gongying {
          background-image: url("../../../assets/image/icon_wldw wxz.png");
        }
      }
      .ant-tabs-tab-active {
        color: #387bfc;
        .icon-image-shangpin {
          background-image: url("../../../assets/image/icon_cgsp xz.png");
        }
        .icon-image-gongying {
          background-image: url("../../../assets/image/icon_wldw xz.png");
        }
      }
      .ant-tabs-nav .ant-tabs-tab:hover {
        color: #387bfc;
        .icon-image-shangpin {
          background-image: url("../../../assets/image/icon_cgsp xz.png");
        }
        .icon-image-gongying {
          background-image: url("../../../assets/image/icon_wldw xz.png");
        }
      }
    }
    .ant-table-wrapper {
      padding: 0;
    }
    .ant-table-thead {
      tr {
        th {
          height: 50px;
          padding: 0 16px !important;
        }
      }
    }
    .ant-table-tbody {
      tr {
        td {
          padding: 0 10px !important;
          height: 54px;
        }
        .ant-input {
          border-radius: 0 !important;
        }
        .blank-input {
          width: 100%;
          height: 54px;
        }
      }
    }
    .ant-table-footer {
      padding: 0 5px 0 0;
      td:last-child {
        border-right: 0 !important;
      }
      .ant-table-body {
        border: 0;
      }
    }
  }
  .pagination-box {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    position: fixed;
    left: 0;
    bottom: 0;
  }
}
</style>
